module.exports = __webpack_public_path__ + "img/cs.ec741919.png";